import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getCommentaryGroupsDraft = api(async function getCommentaryGroupsDraft() {
    return query(
        gql`
            query GetCommentaryGroupsDraft {
                getCommentaryGroupsDraft {
                    id
                    status
                    overview {
                        title
                        content
                    }
                    sections {
                        id
                        custom
                        title
                        description
                        content
                    }
                }
            }
        `,
        {},
        { returns: "getCommentaryGroupsDraft" }
    )
})
